import React from 'react'

const LogOut = ({ size = 16, color = '#DA1E28', ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 16 16"
		fill="none"
		{...props}
	>
		<g clipPath="url(#clip0_2019_10136)">
			<path
				d="M14.33 7.66504H5.44336"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.627 11.3677L14.3297 7.66494L10.627 3.96216"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.44333 14.33H2.48111C2.0883 14.33 1.71157 14.174 1.43381 13.8962C1.15605 13.6184 1 13.2417 1 12.8489V2.48111C1 2.0883 1.15605 1.71157 1.43381 1.43381C1.71157 1.15605 2.0883 1 2.48111 1H5.44333"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2019_10136">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
)

export default LogOut;
